import React, { useEffect, useState } from "react";
import Igcsedata from '../components/igcseData';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import '../css/tabresponsive.css';
import HorizontalTabs from '../components/HorizontalTabs';
// import { useLocation } from 'react-router-dom';





// function Igcse() {
//   const location = useLocation();

//   // Scroll to the section if specified in the URL state
//   useEffect(() => {
//     if (location.state?.scrollTo) {
//       const element = document.getElementById(location.state.scrollTo);
//       if (element) {
//         // Use smooth scrolling to the section
//         element.scrollIntoView({ behavior: "smooth" });
//       }
//     }
//   }, [location]);



function Igcse() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Extract tab name from URL or default to first tab
  const getActiveTabFromURL = () => {
    const params = new URLSearchParams(location.search);
    return params.get("tab") || "Cambridge Lower Secondary"; // Default tab
  };

  const [activeTab, setActiveTab] = useState(getActiveTabFromURL());

  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  // Update URL when the tab changes
  const handleTabChange = (newTab) => {
    setActiveTab(newTab);
    navigate(`?tab=${encodeURIComponent(newTab)}`, { replace: true });
  };

  const tabs = [
    { title: 'Cambridge Lower Secondary', content: () => <div>
    
    <div id='CieCurriculum' className='cam-lower-sec'>

       <div className='Footer-top'>
    <div className='footop-img'>
    {/* <div className='footer-img-box'>
      <img src='../img/british-council.webp'/>
    </div> */}
      
   <div className='footer-img-box'>
    <img src='../img/new-cambridge.webp'/>
      </div>
    
    </div>
    
    </div>
    <h1 className='title'>Cambridge Lower Secondary</h1>
      <h5 className='cam-title-heading'>CHECKPOINT (CP VI – CP VIII)</h5>
      <p>Cambridge Lower Secondary is an international curriculum for grades CP VI to CP VIII for developing skills and understanding in English, Mathematics and Science. There is a curriculum framework for each subject taught in these classes.</p>
      <p>By offering Cambridge Lower Secondary, to our learners we provide a
broad and balanced education to young learners, helping them to thrive throughout their
schooling, work and life. With eight subjects to study, including English, mathematics,
Science, Computing, Wellbeing and French as core subjects of Cambridge we
incorporate study of Hindi and Social Studies in are academic subject study for the
students to develop creativity, expression and wellbeing in a variety of ways.
We have shaped the curriculum around for our students to learn. The curriculum is
flexible, and so the curated curriculum with combination of the subjects available and
adapted the content suits our context, culture and ethos. We offer Cambridge Lower
Secondary alongside our national curriculum, as part of a bilingual programme.</p>
      <p>Each curriculum framework is designed to engage learners in an active and creative learning journey.</p>
      <h5 className='cam-title-heading'>The following are the Subjects studied for Classes CP VI to CP VIII:</h5>
      <p><b>English</b></p>
      <p><b>Science</b></p>
      <p><b>Math</b></p>
      <p><b>Computing</b></p>
      <p><b>French</b></p>
      <p><b>Hindi</b></p>
      <p><b>Social Science</b></p>
      <p><b>Wellbeing</b></p>
      
        <p>Cambridge Lower Secondary English enables learners to communicate confidently and effectively and to develop the skills to respond to a range of information, media and texts with understanding and enjoyment. Learners who follow this framework will develop a first language competency in English based on a curriculum designed to be successful in any culture and to promote cross-cultural understanding.</p>
        <p>The Mathematics curriculum framework explores six content areas: number, algebra, geometry, measure, handling data and problem solving. The first five content areas are all underpinned by problem solving, which provides a structure for the application of mathematical skills. Mental strategies are also an important part of the number content. The curriculum focusses on principles, patterns, systems, functions and relationships, so that learners apply their mathematical knowledge and develop a holistic understanding of the subject.</p>
        <p>This Science curriculum framework covers four content areas: Scientific enquiry, Biology, Chemistry and Physics. Scientific enquiry is about considering ideas, evaluating evidence, planning investigative work, and recording and analysing data. The scientific enquiry objectives underpin Biology, Chemistry and Physics, which are focussed on developing confidence and interest in scientific knowledge. Environmental awareness and some history of science are also part of the curriculum.</p>
        <p>Cambridge Checkpoint tests have been designed to assess learners at the end of Cambridge Lower Secondary in grade 8. They are available in English, Mathematics and Science, and give valuable feedback on learners’ strengths and weaknesses before they progress to the next stage of education</p>
        <p>The tests are marked in Cambridge and provide schools with an external international benchmark for learner performance. Each learner receives a statement of achievement and a diagnostic feedback report, giving schools detailed information and parents extra trust in the feedback they receive.</p>
          <h5 className='cam-title-heading'>The report on a learner gives:</h5>
        <ul>
          <li>A Cambridge Secondary 1 Checkpoint score for the whole subject</li>
          <li>A Cambridge Secondary 1 Checkpoint score for each main topic/skill</li>
          <li>A list of the questions (and the sub-topics/skills) where the candidate’s performance was particularly strong or particularly weak</li>
          <li>A statement of achievement</li>
        </ul>
        <p>For more information please visit at: <Link to="">www.cambridgeinternational.org</Link> </p>
    </div>



      
    </div> },
    // { title: 'Cambridge Upper Secondary', content: () => <div>
    //   <div className='cam-lower-sec'>
    //   <h1 className='title'>Cambridge Upper Secondary</h1>
    //     {/* <h5 className='cam-title-heading'>IGCSE (GRADE IX –X)</h5>
    //     <p>The IGCSE Programme is administered by the University of Cambridge International Examinations (CIE). The IGCSE Programme is firmly established and recognized world-wide; over 9000 schools in 160 countries offer the Cambridge qualifications. It has worldwide recognition and is equivalent to the Certificate of Secondary Education from Indian education boards, General Certificate of Secondary Education.</p>
    //     <p>IGCSE provides an ideal foundation for higher-level courses such as the International Baccalaureate Diploma Programme, 'A' Levels and the American Advanced Placement Test.</p>
    //     <p>The Cambridge IGCSE curriculum offers a variety of routes for learners starting from a foundation of Core level to extended level of subjects, making it suitable for a wide range of abilities.</p>
    //     <p>Encouraging learners to engage with a variety of subjects, and make connections between them, is fundamental to our approach.
    //     </p>
    //       <h5 className='cam-title-heading'>IGCSE develops learner knowledge, understanding and skills in:</h5>
    //     <ul>
    //       <li>Subject content</li>
    //       <li>Applying knowledge and understanding to new as well as unfamiliar situations</li>
    //       <li>Intellectual enquiry</li>
    //       <li>Flexibility and responsiveness to change</li>
    //       <li>Cultural awareness</li>
    //     </ul> */}
    //   </div>
    // </div> },
    { title: 'The IGCSE Curriculum At Sanskar', content: () => <div>

      <div className='cam-lower-sec'>

            <div className='Footer-top'>
    <div className='footop-img'>
    {/* <div className='footer-img-box'>
      <img src='../img/british-council.webp'/>
    </div> */}
      
   <div className='footer-img-box'>
    <img src='../img/new-cambridge.webp'/>
      </div>
    
    </div>
    
    </div>
    
        <h1 className='title'>The IGCSE Curriculum At Sanskar</h1>
        <h5 className='cam-title-heading'>IGCSE (GRADE IX –X)</h5>
        <p>The International General Certificate of Secondary Education (IGCSE) Programme is administered by the University of Cambridge International Examinations (CIE). The IGCSE Programme is firmly established and recognized world-wide; over 9000 schools in 140 countries offer the Cambridge qualifications. It has worldwide recognition and is equivalent to the Certificate of Secondary Education from Indian education boards, General Certificate of Secondary Education.</p>
        <p>IGCSE provides an ideal foundation for higher-level courses such as the International Baccalaureate Diploma Programme, 'A' Levels and the American Advanced Placement Test.</p>
        <p>The Cambridge IGCSE curriculum offers a variety of routes for learners starting from a foundation of Core level to extended level of subjects, making it suitable for a wide range of abilities.</p>
        <p>Encouraging learners to engage with a variety of subjects, and make connections between them, is fundamental to our approach.
        </p>
          <h5 className='cam-title-heading'>IGCSE develops learner knowledge, understanding and skills in:</h5>
        <ul>
          <li>Subject content</li>
          <li>Applying knowledge and understanding to new as well as unfamiliar situations</li>
          <li>Intellectual enquiry</li>
          <li>Flexibility and responsiveness to change</li>
          <li>Cultural awareness</li>
        </ul>
        <p>At Sanskar, we proudly offer the International General Certificate of Secondary Education (IGCSE), a globally recognized qualification designed to empower students with the knowledge, skills, and confidence to excel in the modern world. This program provides a broad and balanced curriculum, catering to diverse learning styles which further prepares students for better education and career opportunities. With a focus on academic excellence and personal growth, it helps students to encourage critical thinking, creativity, and problem-solving skills.</p>
        <p>The IGCSE curriculum at Sanskar School is broad and balanced, providing a diverse range of subjects groups across languages, sciences, humanities, mathematics, creative, technical and vocational. Which helps our students to alter their learning journey in accordance with their interests and aspirations. This variety enables our students to explore their interests, tailor their educational paths, and unlock their full potential. Our approach encourages critical thinking, creativity, and problem-solving skills, ensuring that every learner emerges as an independent thinker ready to excel in higher education and beyond</p>
        <p>At Sanskar, world-class teaching and resources form the cornerstone of our IGCSE program, with experienced educators, cutting-edge facilities, and small class sizes, we ensure that every student receives personalized attention. By focusing on each individual’s unique strengths and areas for improvement, we create a supportive and stimulating environment that fosters growth and achievement. Beyond academics, the IGCSE journey at Sanskar School embodies our ethos of holistic development. From engaging co-curricular activities to leadership opportunities and community initiatives, we strive to cultivate compassionate, resourceful, and globally aware citizens who are ready to make a positive difference in the world.</p>

        {/* <p>Sanskar offers 18 subjects at the IGCSE level. These are offered under 5 groups. for the ICE award. Students are required to choose seven subjects as follows. - Two languages, and one subject from each of the other subject groups: Humanities and Social sciences, Sciences, Mathematics and Business, Creative, Technical & Vocational. This accounts for 6 Subjects. The 7th subject may belong to any group from 2 to 5. A student can choose up to a maximum of 9 subjects.</p> */}
        <h5 className='cam-title-heading' >The IGCSE is a two-year course of study available to students at Sanskar in Classes IX and X. The following are the subject Choices for Classes IX and X:</h5>
        {/* <p><b>Art & Design (0440)</b></p>
        <p><b>French (0520)</b></p>
        <p><b>English (0580)</b></p>
        <p><b>Math (0580)</b></p>
        <p><b>Biology (0610)</b></p>
        <p><b>Business Studies (0450)</b></p>
        <p><b>Chemistry (0455)</b></p>
        <p><b>Environmental Management (0680)</b></p>
        <p><b>Global Perspectives (0457)</b></p>
        <p><b>Hindi (0549)</b></p>
        <p><b>ICT (0417)</b></p>
        <p><b>Physics (0417)</b></p> */}


        <div className='cam-lower-table'> 
     
     {/* <h1>table data baki ha abhi</h1> */}
     
      <table>
       <thead>
         <tr>
          
           <th>Group 1 (Languages)</th>
           <th>Group 2 (Humanities )</th>
           <th>Group 3 (Sciences)</th>
           <th>Group 4 (Mathematics)</th>
           <th>Group 5 (Creative, Technical & Vocational)</th>
           
         </tr>
       </thead>
       <tbody>
         <tr>
           <td>
             <ul>
               <li>English (0500) (Compulsory)</li>
               <li>Hindi (0549) (Optional)</li>
               <li>French (0520) (Optional)</li>
               </ul>  
                {/* First Language English / A Second Language Hindi / A Foreign Language French */}
               </td>
           <td>
             <ul>
               <li>Economics (0455)</li>
               <li>Global Perspectives (0457)</li>
             
               </ul>  
           </td>
           <td>
             <ul>
               <li>Physics (0625)</li>
               <li>Chemistry (0620)</li>
               <li>Biology (0610)</li>
               <li>Environmental Management (0680)</li>
             </ul>
     
     
           </td>
           <td>Math (0580)</td>
           <td>
           <ul>
               <li>Art & Design (0400)</li>
               <li>Business Studies (0450)</li>
               <li>ICT (0417)</li>
             
             </ul>
     
     
           </td>
         </tr>
        </tbody>
             </table>
             </div>  

        {/* <div className='cam-lower-table'> */}
     
     {/* <h1>table data baki ha abhi</h1> */}
     
     {/* <table>
       <thead>
         <tr>
          
           <th>Group 1 (Languages)</th>
           <th>Group 2 (Humanities & Social Sciences)</th>
           <th>Group 3 (Sciences)</th>
           <th>Group 4 (Mathematics)</th>
           <th>Group 5 (Creative, Technical & Vocational)</th>
           
         </tr>
       </thead>
       <tbody>
         <tr>
           <td>First Language English / A Second Language Hindi / A Foreign Language French</td>
           <td>Economics / Global Perspectives</td>
           <td>Physics / Chemistry / Biology / Environmental Management </td>
           <td>International Mathematics / Extended Mathematics</td>
           <td>Art & Design / Business Studies / ICT </td>
         </tr>
        </tbody>
             </table> */}
             {/* </div>  */}
        <h5 className='cam-title-heading'> The IGCSE Assessment</h5>
        <p>Cambridge IGCSE assessment takes place at the end of the course and includes written, oral, coursework and practical assessment. This broadens opportunities for students to demonstrate their learning.</p>
        <p>Grades are benchmarked using eight internationally recognized grades, A* to G ;( A*indicating highest performance and G the minimum satisfactory performance)</p>
        <p>Cambridge ICE Group Award stands for International Certificate of Education. At the IGCSE one needs to choose a minimum of 7 subjects and select at least one subject from each of the five groups to qualify for the ICE Award.</p>
          <h5 className='cam-title-heading' >The ICE may be awarded at one of the three levels:</h5>
        <ul>
          <li>Distinction to students who receive Grade A or above in 5 subjects (English + 4 Subjects) and Grade C or above in two subjects;</li>
          <li>Merit to students who receive Grade B or above in 5 subjects (English + 4 Subjects) and Grade G or above in two subjects;</li>
          <li>Pass to students who receive Grade G or above in 5 subjects (English + 4 Subjects) </li>
        </ul>
        <p><b>For more information please visit at: </b><Link to='https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-upper-secondary/cambridge-igcse'>www.cambridgeinternational.org</Link></p>
      </div>


    </div> },
  
  ];

  
  return (
    <div>

<div className='ibdp-hero-sec'>
        <img src='newimg/img2.webp'/>

      </div>
      <div className='igcse-data'>
    
      {/* <Igcsedata/> */}
      {/* <HorizontalTabs tabs={tabs} /> */}

      <HorizontalTabs tabs={tabs} activeTab={activeTab} onTabChange={handleTabChange} />
      </div>
   
    </div>
  )
}

export default  Igcse;
